import { Navigate, createRouter } from '@tanstack/react-router';

import { CheckoutResponse } from 'src/api/models/cart';

import Page500 from 'src/sections/error/500-view';

import { rootRoute } from './root';
import { eulaRoute } from './eula';
import { guideRoute } from './guide';
import { notFoundRoute } from './404';
import { forbiddenRoute } from './403';
import { authRouteTree } from './auth';
import { userRouteTree } from './user';
import { newsRouteTree } from './news';
import { indexRoute } from './index-route';
import { ordersRouteTree } from './orders';
import { storiesRouteTree } from './stories';
import { financeRouteTree } from './finance';
import { productsRouteTree } from './products';
import { checkoutRouteTree } from './checkout';
import { producersRouteTree } from './producers';
import { howToLoginRoute } from './how-to-login';
import { reportingRouteTree } from './reporting';
import { favouritesRouteTree } from './favourites';
import { resetPasswordRoute } from './reset-password';
import { forgotPasswordRoute } from './forgot-password';
import { insufficientRoleRoute } from './insufficient-role';
import { seasonalCalendarRouteTree } from './seasonal-calendar';
import { issuesRouteTree, issuesAnonymousRouteTree } from './issues';

const routeTree = rootRoute.addChildren([
  indexRoute,
  notFoundRoute,
  forbiddenRoute,
  insufficientRoleRoute,
  eulaRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  howToLoginRoute,
  guideRoute,
  authRouteTree,
  productsRouteTree,
  favouritesRouteTree,
  checkoutRouteTree,
  ordersRouteTree,
  issuesRouteTree,
  issuesAnonymousRouteTree,
  userRouteTree,
  newsRouteTree,
  storiesRouteTree,
  producersRouteTree,
  seasonalCalendarRouteTree,
  reportingRouteTree,
  financeRouteTree,
]);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof mainRouter;
  }
  interface HistoryState {
    checkoutData: CheckoutResponse;
  }
}

// Create the router instance
export const mainRouter = createRouter({
  routeTree,
  defaultErrorComponent: () => <Page500 />,
  defaultNotFoundComponent: () => <Navigate to="/404" />,
});
